import { object, string } from 'yup';

import { getMaxLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_DESCRIPTION_LENGTH } from '@constants/validationMessages';

export const validationSchema = object({
	text: string()
		.trim()
		.default('')
		.max(MAX_DESCRIPTION_LENGTH, getMaxLengthErrMsg('Comments', MAX_DESCRIPTION_LENGTH))
		.required(validationErrMessages.comment),
});
